import {getCadCategories, getConstructions, searchCad} from '../api/cad';
import filter from 'lodash/filter';

export const cadModule = {
    namespaced: true,
    state: {
        type: 'cad',
        categrories: {
            list: [],
            processing: false,
        },
        documents: {
            list: [],
            processing: false,
        }
    },
    getters: {
        processing(state) {
            return state.documents.processing;
        },
        categories(state) {
            return state.categrories.list;
        },
        documents(state) {
            return state.documents.list;
        },
        rootCategories(state, getters) {
            return filter(getters.categories, category => category.parentSlug === null);
        },
        type(state) {
            return state.type;
        }
    },
    actions: {
        setType({commit}, type) {
            commit('setType', type);
        },
        fetchCategories({commit, getters}) {
            let clbFunction = {
                cad: () => getCadCategories(),
                documents: () => getCategories(),
            };
            commit('fetchCategoriesProcess', true);
            return clbFunction[getters.type]()
                .then((data) => {
                    commit('setCategories', data);
                    commit('fetchCategoriesProcess', false);
                }).catch(() => {
                    commit('setCategories', []);
                    commit('fetchCategoriesProcess', false);
                });
        },
        fetchDocuments({commit, getters}, categoryId) {
            commit('fetchDocumentsProcess', true);
            commit('setDocuments', []);
            if (null === categoryId) {
                return null;
            }
            let clbFunction = {
                cad: (categoryId) => getConstructions(categoryId),
                documents: (categoryId) => getDocuments(categoryId),
            };
            return clbFunction[getters.type](categoryId)
                .then((data) => {
                    commit('setDocuments', data);
                    commit('fetchDocumentsProcess', false);
                }).catch(() => {
                    commit('setDocuments', []);
                    commit('fetchDocumentsProcess', false);
                });
        },
        searchDocuments({commit, getters}, s) {
            commit('fetchDocumentsProcess', true);
            commit('setDocuments', []);
            return searchCad(s)
                .then((data) => commit('setDocuments', data))
                .catch(() => commit('setDocuments', []))
                .finally(() => commit('fetchDocumentsProcess', false));
        },
        setDocuments({commit}, documents) {
            commit('setDocuments', documents);
        }
    },
    mutations: {
        setCategories(state, categories = []) {
            state.categrories.list = categories;
        },
        setDocuments(state, documents = []) {
            state.documents.list = documents;
        },
        fetchCategoriesProcess(state, status) {
            state.categrories.processing = status;
        },
        fetchDocumentsProcess(state, status) {
            state.documents.processing = status;
        },
        setType(state, type) {
            state.type = type;
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/cad/store/index.js